var map = {
	"./denisa-gafova.jpg": 51377,
	"./jan-svoboda.jpg": 48442,
	"./kamila-pilna.jpg": 53918,
	"./karel-antos.jpg": 71671,
	"./lada-kosova.jpg": 11362,
	"./petr-jaros.jpg": 66943,
	"./quote.svg": 24710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24468;